var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "payment-link-order" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            attrs: {
              model: _vm.form,
              "label-width": "250px",
              "label-position": "left",
            },
          },
          [
            _vm.tableData && _vm.tableData.length > 0
              ? [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("payment_links.product_info"))),
                  ]),
                  _c(
                    "div",
                    { staticClass: "tableContainer" },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.tableData,
                            stripe: "",
                            fit: "",
                            "highlight-current-row": "",
                            "max-height": "500px",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("payment_links.product_name"),
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " + _vm._s(scope.row.name) + " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2507105690
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("payment_links.price"),
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("toDivideWithDot")(
                                              scope.row.price
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1603258332
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("payment_links.quantity"),
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " + _vm._s(scope.row.quantity) + " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1917492518
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("payment_links.amount"),
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("toDivideWithDot")(
                                              scope.row.total_amount
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1713703360
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("payment_links.customer_info"))),
            ]),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.customer_name") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("strAesDecryptAndAsterisk")(_vm.form.customer_name)
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.customer_email") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(
                    _vm._s(_vm._f("strAesDecryptAndAsterisk")(_vm.form.email))
                  ),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.customer_mobile") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(
                    _vm._s(_vm._f("strAesDecryptAndAsterisk")(_vm.form.mobile))
                  ),
                ]),
              ]
            ),
            _vm.fieldInfoList.length > 0
              ? [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("payment_links.other_info"))),
                  ]),
                  _vm._l(_vm.fieldInfoList, function (item, index) {
                    return _c(
                      "el-form-item",
                      { key: index, attrs: { label: item.name } },
                      [
                        _c("span", { staticClass: "content-text" }, [
                          _vm._v(_vm._s(item.value)),
                        ]),
                      ]
                    )
                  }),
                ]
              : _vm._e(),
            _vm.branch_code
              ? _c("el-form-item", { attrs: { label: "Branch Code" } }, [
                  _c("span", { staticClass: "content-text" }, [
                    _vm._v(_vm._s(_vm.branch_code)),
                  ]),
                ])
              : _vm._e(),
            _vm.branch_name
              ? _c("el-form-item", { attrs: { label: "Branch Name" } }, [
                  _c("span", { staticClass: "content-text" }, [
                    _vm._v(_vm._s(_vm.branch_name)),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }